import { Inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { formatObject } from '../../../../../base/utils/format-object';
import { BetslipError } from '../../../errors/betslip-error';
import { MinimumComboPreCheckError } from '../../../errors/pre-check/minimum-combo-pre-check-error';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class MinimumCombinationMessageFormatter extends MessageFormatter<MinimumComboPreCheckError> {
    private messages: IBetslipMessages;
    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService) {
        super();
        this.messages = messageProvider.getMessages();
    }

    format(error: MinimumComboPreCheckError): Observable<string> {
        // min combo string in site core: This pick must be combined  with at least {expectedOptions} additional picks
        return of(
            formatObject(this.messages.validation.MinimumCombo, {
                expectedOptions: error.expectedCount as number,
            }),
        );
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof MinimumComboPreCheckError;
    }
}
